import React from 'react';
import styled from 'styled-components';
import { Spacing16 } from 'autogen/design-tokens/tokens';
import type { MenuSectionViewModel } from 'autogen/swagger/all';
import Menu from 'components/generic/menu';
import type { IMenuSection } from 'components/generic/menu/shared/types';
import { breakpoint, sizes } from 'variables';
import { GreyCapitalHeadline } from './SectionHeadlineRenderer';

/**
 * SectionStyleRenderer handles the styling variations of MenuSection that can come from MenuSectionViewModel
 */

type SectionStyleRenderer = IMenuSection & {
    styling: MenuSectionViewModel['styling'];
};

const BoxedSection = styled(Menu.BoxedSection)`
    margin: 0 ${Spacing16} ${Spacing16};

    ${breakpoint.up(sizes.md)} {
        margin: 0 ${Spacing16} ${Spacing16};
    }
`;

const SecondarySection = styled(Menu.SecondarySection)`
    margin-bottom: ${Spacing16};

    ${GreyCapitalHeadline} + & {
        padding-top: 0;
    }
`;

export default function SectionStyleRenderer(props: SectionStyleRenderer) {
    const { styling } = props;

    switch (styling) {
        case 'BoxedSection':
            return <BoxedSection {...props} listProps={{ divider: true }} />;
        case 'SecondarySection':
            return <SecondarySection {...props} />;
        case 'SecondarySectionWithDividers':
            return <SecondarySection {...props} listProps={{ divider: true }} />;
        default:
            return <Menu.Section {...props} />;
    }
}
